import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_REPORT_PACKAGE_LIST = "GET_REPORT_PACKAGE_LIST";

export const service = async (data) => {
  const options: object = {
    url: `/api/ReportPackage/GetReportPackageList/${data.userId}/${data.isExternalReport}`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_REPORT_PACKAGE_LIST, service, mock);
